// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__jeUiH","savePackageButton":"ClientWallet_savePackageButton__k0vIT"};